import { useAuthStore } from "@/stores";
import axios from "axios";

export function http() {
  const authStore = useAuthStore();

  const instance = axios.create({
    baseURL: "/api",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `Bearer ${authStore.$state.token}`,
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const dealerDomain = authStore.dealerDomain || localStorage.getItem('dealer_domain');

      if (dealerDomain) {
        config.headers['X-Dealer-Subdomain'] = dealerDomain;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
}
